import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.1421 1.49995C16.1421 0.947669 15.6944 0.499954 15.1421 0.499954L6.14214 0.499955C5.58985 0.499954 5.14214 0.94767 5.14214 1.49995C5.14214 2.05224 5.58985 2.49995 6.14214 2.49995L14.1421 2.49995L14.1421 10.5C14.1421 11.0522 14.5899 11.5 15.1421 11.5C15.6944 11.5 16.1421 11.0522 16.1421 10.5L16.1421 1.49995ZM1.70711 16.3492L15.8492 2.20706L14.435 0.792848L0.292893 14.935L1.70711 16.3492Z",
    fill: "white"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "custom_button",
    href: "https://t.me/MT_SHOP_Support",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLeadClick && _ctx.onLeadClick(...args)))
  }, [
    _createElementVNode("span", null, [
      _createTextVNode(_toDisplayString(_ctx.t('landingMTShop.advantages.btnContact')) + " ", 1),
      _hoisted_1
    ])
  ]))
}